import React from "react";
import { Image } from "react-native";
import { getColorConfig } from "../constants/colors";
import { createStackNavigator } from "@react-navigation/stack";
import HomeScreen from "../pages/Home/HomeScreen";
import TextFields from "../components/text-fields";
import ProfileScreen from "../pages/Profile/ProfileScreen";
import HospitalLogoTitle from "../components/hospital-logo-title";
import TouchableWithAnimation from "../components/touchable-with-animation";
import EducationDetailScreen from "../pages/Education/EducationDetailScreen";
import DischargeInstructionsScreen from "../pages/DischargeInstructionsScreen";
import EmptyReminderScreen from "../pages/HealthData/Medications/MedicationReminder/EmptyReminderScreen";
import MedicationLogRemindersList from "../pages/HealthData/Medications/MedicationLog/MedicationLogRemindersList";
import LanaAppState from "../utils/lana-app-state";

const Stack = createStackNavigator();

export default class HomeScreenNavigator extends React.Component {
    constructor(props) {
        super(props);
    }
    openProfileScreen = () => {
        this.props.navigation.navigate("ProfileScreen");
    };

    render() {
        return (
            <Stack.Navigator
                screenOptions={{
                    cardStyle: { backgroundColor: "#F8F7F7" },
                }}
            >
                <Stack.Screen
                    name="HomeScreen"
                    component={HomeScreen}
                    options={{
                        headerTitle: (props) => (
                            <HospitalLogoTitle {...props} />
                        ),
                        headerTitleAlign: "center",
                        headerRight: ({ focused }) => (
                            <>
                                {LanaAppState.getInstance().getEnabledAuthFeatures().includes("PROFILE") &&
                                    <TouchableWithAnimation
                                        onPress={this.openProfileScreen}>
                                        <Image
                                            style={{
                                                marginRight: 16,
                                                width: 28,
                                                height: 28,
                                            }}
                                            source={
                                                focused
                                                    ? require("../../assets/profile/profileIconSelected.png")
                                                    : require("../../assets/profile/profileIconUnselected.png")
                                            }
                                        />
                                    </TouchableWithAnimation>
                                }
                            </>
                        ),
                        headerStyle: {
                            shadowColor: "#B3A8A8",
                            shadowOffset: { width: 0, height: 4 },
                            shadowOpacity: 0.2,
                            shadowRadius: 8,
                            elevation: 5,
                        },
                    }}
                />
                <Stack.Screen
                    name="DischargeInstructionsScreen"
                    component={DischargeInstructionsScreen}
                    options={{
                        headerTitle: () => (
                            <TextFields.TitleText2>
                                Discharge Instructions
                            </TextFields.TitleText2>
                        ),
                        headerTitleAlign: "center",
                        headerBackTitle: " ",
                        headerTintColor: getColorConfig().primaryColor,
                        headerStyle: {
                            shadowColor: "#B3A8A8",
                            shadowOffset: { width: 0, height: 4 },
                            shadowOpacity: 0.2,
                            shadowRadius: 8,
                            elevation: 5,
                        },
                    }}
                />
                <Stack.Screen
                    name="EducationDetailScreen"
                    component={EducationDetailScreen}
                    options={{
                        headerTitle: (props) => (
                            <HospitalLogoTitle {...props} />
                        ),
                        headerTitleAlign: "center",
                        headerBackTitle: " ",
                        headerTintColor: getColorConfig().primaryColor,
                        headerStyle: {
                            shadowColor: "#B3A8A8",
                            shadowOffset: { width: 0, height: 4 },
                            shadowOpacity: 0.2,
                            shadowRadius: 8,
                            elevation: 5,
                        },
                    }}
                />
                <Stack.Screen
                    name="ProfileScreen"
                    component={ProfileScreen}
                    options={{
                        headerTitle: () => (
                            <TextFields.TitleText2>
                                My Profile
                            </TextFields.TitleText2>
                        ),
                        headerTitleAlign: "center",
                        headerBackTitle: " ",
                        headerTintColor: getColorConfig().primaryColor,
                        headerStyle: {
                            shadowColor: "#B3A8A8",
                            shadowOffset: { width: 0, height: 4 },
                            shadowOpacity: 0.2,
                            shadowRadius: 8,
                            elevation: 5,
                        },
                    }}
                />
                <Stack.Screen
                    name="MedicationLogRemindersList"
                    component={MedicationLogRemindersList}
                    options={{
                        headerTitle: () => (
                            <TextFields.TitleText2>
                                My Reminders
                            </TextFields.TitleText2>
                        ),
                        headerTitleAlign: "center",
                        headerBackTitle: " ",
                        headerTintColor: getColorConfig().primaryColor,
                        headerStyle: {
                            shadowColor: "#B3A8A8",
                            shadowOffset: { width: 0, height: 4 },
                            shadowOpacity: 0.2,
                            shadowRadius: 8,
                            elevation: 5,
                        },
                    }}
                />
                <Stack.Screen
                    name="EmptyReminderScreen"
                    component={EmptyReminderScreen}
                    options={{
                        headerTitle: () => (
                            <TextFields.TitleText2>
                                My Reminders
                            </TextFields.TitleText2>
                        ),
                        headerTitleAlign: "center",
                        headerBackTitle: " ",
                        headerTintColor: getColorConfig().primaryColor,
                        headerStyle: {
                            shadowColor: "#B3A8A8",
                            shadowOffset: { width: 0, height: 4 },
                            shadowOpacity: 0.2,
                            shadowRadius: 8,
                            elevation: 5,
                        },
                    }}
                />
            </Stack.Navigator>
        );
    }
}
